var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "startedByme" },
    [
      _c(
        "el-tabs",
        {
          attrs: { value: _vm.tabActiveName },
          on: { "tab-click": _vm.handleTabClick },
        },
        [
          _vm.$hasBtnRoles("/user/project-delivery/ticket-initiated-by-me")
            ? _c(
                "el-tab-pane",
                { attrs: { label: "个性化项目工单", name: "1" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "searchForm",
                      attrs: { id: "searchDom", inline: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "项目ID" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入项目ID",
                            },
                            model: {
                              value: _vm.searchForm.number,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "number", $$v)
                              },
                              expression: "searchForm.number",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "项目状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                multiple: "",
                                "collapse-tags": "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.searchForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "status", $$v)
                                },
                                expression: "searchForm.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "待审批", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "项目待过会", value: 100 },
                              }),
                              _c("el-option", {
                                attrs: { label: "处理中", value: 200 },
                              }),
                              _c("el-option", {
                                attrs: { label: "部分完成", value: 399 },
                              }),
                              _c("el-option", {
                                attrs: { label: "已完成", value: 400 },
                              }),
                              _c("el-option", {
                                attrs: { label: "审批驳回", value: 500 },
                              }),
                              _c("el-option", {
                                attrs: { label: "已终止", value: 600 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户名称" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input__width",
                              attrs: {
                                remote: "",
                                "remote-method": _vm.getCompanyList,
                                clearable: "",
                                filterable: "",
                                placeholder: "请输入公司名称",
                              },
                              model: {
                                value: _vm.searchForm.customer_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "customer_id", $$v)
                                },
                                expression: "searchForm.customer_id",
                              },
                            },
                            _vm._l(_vm.companyList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.company_name + "（" + item.id + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "项目名称" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入项目名称",
                            },
                            model: {
                              value: _vm.searchForm.project_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "project_name", $$v)
                              },
                              expression: "searchForm.project_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "项目类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "230px" },
                              attrs: {
                                multiple: "",
                                "collapse-tags": "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.searchForm.project_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "project_type", $$v)
                                },
                                expression: "searchForm.project_type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: "个性化项目评估（启动会）",
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: { label: "其他个性化需求", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "任务" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                multiple: "",
                                "collapse-tags": "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.searchForm.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "type", $$v)
                                },
                                expression: "searchForm.type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "商城装修", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "投标支持", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "定制设计印刷", value: 3 },
                              }),
                              _c("el-option", {
                                attrs: { label: "报价单", value: 9 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { type: "primary" },
                              on: { click: _vm.resetList },
                            },
                            [_vm._v("搜 索")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { type: "success" },
                              on: { click: _vm.toCreate },
                            },
                            [_vm._v("提申请")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        border: "",
                        "header-cell-style": {
                          background: "#f1f1f1",
                          color: "#333333",
                        },
                        align: "center",
                        data: _vm.listData,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "项目ID/项目状态", width: "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [_vm._v(_vm._s(scope.row.number))]),
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.status_cn)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3499659665
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "客户名称/项目名称" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.customer_name) +
                                        "(" +
                                        _vm._s(scope.row.customer_id) +
                                        ") "
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.project_name)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3671471295
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "项目类型/任务", width: "160" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.project_type_cn)),
                                  ]),
                                  _vm._l(
                                    scope.row.type_of_demand,
                                    function (value, index) {
                                      return _c("div", { key: index }, [
                                        _c("span", [
                                          _vm._v(_vm._s(value.type_cn)),
                                        ]),
                                        _vm._v(" （ "),
                                        _c(
                                          "span",
                                          {
                                            style: {
                                              color:
                                                {
                                                  1: "#409EFF",
                                                  50: "#E6A23C",
                                                  100: "#F56C6C",
                                                  200: "#409EFF",
                                                  201: "#409EFF",
                                                  300: "#909399",
                                                  400: "#F56C6C",
                                                  800: "#909399",
                                                }[value.status] || "#409EFF",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                {
                                                  1: "待审批",
                                                  50: "待分配",
                                                  100:
                                                    value.type == 2
                                                      ? "标书处理中"
                                                      : "处理中",
                                                  200: "待验收",
                                                  201: "设计完成待确认",
                                                  300:
                                                    value.type == 2
                                                      ? "标书已完成待开标"
                                                      : "已完成",
                                                  400: "审批驳回",
                                                  450: "已开标未出结果",
                                                  500: "未中标",
                                                  550: "中标未交付",
                                                  600: "中标已交付",
                                                  800: "已失效",
                                                }[value.status]
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" ） "),
                                      ])
                                    }
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          955745316
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "负责人/审批人",
                          prop: "head",
                          width: "110",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._l(
                                    scope.row.head,
                                    function (value, index) {
                                      return _c("div", { key: index }, [
                                        _vm._v(" " + _vm._s(value) + " "),
                                      ])
                                    }
                                  ),
                                  _vm._l(
                                    scope.row.approver,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        { key: "approver" + index },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.formatApprover(item)) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4224000680
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "提交人/提交时间", width: "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.create_name)),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.user_organize_name)
                                    ),
                                  ]),
                                  scope.row.create_name
                                    ? _c("div", [
                                        _vm._v(_vm._s(scope.row.created_at)),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1269255217
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "处理人/处理时间", width: "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.handler_name)),
                                  ]),
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.updated_at)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          365005387
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "跟进记录", prop: "operation" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.operation &&
                                  scope.row.operation.length > 9
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "tipBox",
                                          attrs: {
                                            "popper-class": "popperTipBox",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            _vm._l(
                                              scope.row.operation,
                                              function (value, index) {
                                                return _c(
                                                  "div",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          value.created_at
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          value.operation_id
                                                        ) +
                                                        " " +
                                                        _vm._s(value.content) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._l(
                                            scope.row.operation,
                                            function (value, index) {
                                              return _c("div", { key: index }, [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(value.created_at) +
                                                    " " +
                                                    _vm._s(value.operation_id) +
                                                    " " +
                                                    _vm._s(value.content) +
                                                    " "
                                                ),
                                              ])
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _c(
                                        "div",
                                        _vm._l(
                                          scope.row.operation,
                                          function (value, index) {
                                            return _c("div", { key: index }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(value.created_at) +
                                                  " " +
                                                  _vm._s(value.operation_id) +
                                                  " " +
                                                  _vm._s(value.content) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3463555537
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "180" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewDetail(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  ),
                                  scope.row.status == 500 ||
                                  (scope.row.project_type == 2 &&
                                    scope.row.status != 400 &&
                                    scope.row.status != 600) ||
                                  _vm.hasQuotationTaskStatus(scope.row, 800)
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toAgain(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("再次发起")]
                                      )
                                    : _vm._e(),
                                  scope.row.type_of_demand &&
                                  scope.row.type_of_demand.some(function (
                                    item
                                  ) {
                                    return item.type == 1 && item.status == 200
                                  })
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toAccept(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("装修验收")]
                                      )
                                    : _vm._e(),
                                  scope.row.type_of_demand &&
                                  scope.row.type_of_demand.some(function (
                                    item
                                  ) {
                                    return item.type == 3 && item.status == 201
                                  })
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDesignConfirm(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("设计确认")]
                                      )
                                    : _vm._e(),
                                  _vm.hasQuotationTaskStatus(scope.row, 300)
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            loading:
                                              _vm.orderLoadingId ===
                                              scope.row.id,
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openOrderDialog(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("下单")]
                                      )
                                    : _vm._e(),
                                  _vm.hasQuotationTaskStatus(scope.row, 300)
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            loading:
                                              _vm.orderLoadingId ===
                                              scope.row.id,
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewOrderList(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("查看订单")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1731139973
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "pages",
                      staticStyle: { "text-align": "right", margin: "16px 0" },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "current-page": _vm.listPages.currentPage,
                          "page-size": _vm.searchForm.pageSize,
                          "page-sizes": [20, 50, 100, 200, 500],
                          total: _vm.listPages.totalCount,
                          layout: "total,sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "current-change": _vm.handlePageChange,
                          "size-change": _vm.sizeChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-ticket/ticket-initiated-by-me")
            ? _c(
                "el-tab-pane",
                { attrs: { label: "咨询工单", name: "2" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ticketSearchForm",
                      attrs: { id: "ticketSearchDom", inline: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "工单编号" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入工单编号",
                            },
                            model: {
                              value: _vm.ticketSearchForm.work_order_no,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ticketSearchForm,
                                  "work_order_no",
                                  $$v
                                )
                              },
                              expression: "ticketSearchForm.work_order_no",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "工单标题" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入工单标题",
                            },
                            model: {
                              value: _vm.ticketSearchForm.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.ticketSearchForm, "title", $$v)
                              },
                              expression: "ticketSearchForm.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "咨询事项" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "230px" },
                            attrs: {
                              options: _vm.ticketCategoryTree,
                              props: {
                                multiple: true,
                                label: "name",
                                value: "id",
                                children: "children",
                              },
                              "collapse-tags": "",
                              clearable: "",
                              filterable: "",
                              placeholder: "请选择",
                            },
                            model: {
                              value: _vm.ticketSearchForm.second_category_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ticketSearchForm,
                                  "second_category_id",
                                  $$v
                                )
                              },
                              expression: "ticketSearchForm.second_category_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "具体事项" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入具体事项",
                            },
                            model: {
                              value: _vm.ticketSearchForm.item,
                              callback: function ($$v) {
                                _vm.$set(_vm.ticketSearchForm, "item", $$v)
                              },
                              expression: "ticketSearchForm.item",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { type: "primary" },
                              on: { click: _vm.ticketResetList },
                            },
                            [_vm._v("搜 索")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: { click: _vm.openTicketDrawer },
                            },
                            [_vm._v("事项咨询")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        border: "",
                        "header-cell-style": {
                          background: "#f1f1f1",
                          color: "#333333",
                        },
                        align: "center",
                        data: _vm.ticketListData,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "工单信息", width: "240" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      "ID：" + _vm._s(scope.row.work_order_no)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v("标题：" + _vm._s(scope.row.title)),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "提交时间：" +
                                        _vm._s(scope.row.created_at)
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2093555840
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "咨询事项" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.category || "-")),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.second_category || "-")
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.item || "-")),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2269019686
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "事项描述", "min-width": "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.description
                                    ? _c(
                                        "el-tooltip",
                                        { attrs: { placement: "top" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ticketDescTip",
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.description
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "ticketDescBox" },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.description)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("span", [_vm._v("-")]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          396340996
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "当前处理人", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (scope.row.handler_list &&
                                          scope.row.handler_list
                                            .map(function (item) {
                                              return item.handler_name
                                            })
                                            .join("、")) ||
                                          "-"
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2562624227
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "处理结果", width: "90" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        {
                                          10: "待分配",
                                          20: "处理中",
                                          30: "已解决",
                                        }[scope.row.status] || "-"
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3846795357
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "跟进记录" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.operation &&
                                  scope.row.operation.length > 9
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "tipBox",
                                          attrs: {
                                            "popper-class": "popperTipBox",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            _vm._l(
                                              scope.row.operation,
                                              function (value, index) {
                                                return _c(
                                                  "div",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          value.created_at
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          value.operation_id
                                                        ) +
                                                        " " +
                                                        _vm._s(value.content) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._l(
                                            scope.row.operation,
                                            function (value, index) {
                                              return _c("div", { key: index }, [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(value.created_at) +
                                                    " " +
                                                    _vm._s(value.operation_id) +
                                                    " " +
                                                    _vm._s(value.content) +
                                                    " "
                                                ),
                                              ])
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _c(
                                        "div",
                                        _vm._l(
                                          scope.row.operation,
                                          function (value, index) {
                                            return _c("div", { key: index }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(value.created_at) +
                                                  " " +
                                                  _vm._s(value.operation_id) +
                                                  " " +
                                                  _vm._s(value.content) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3463555537
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewTicketDetail(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1429534887
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "pages",
                      staticStyle: { "text-align": "right", margin: "16px 0" },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "current-page": _vm.ticketListPages.currentPage,
                          "page-size": _vm.ticketSearchForm.pageSize,
                          "page-sizes": [20, 50, 100, 200, 500],
                          total: _vm.ticketListPages.totalCount,
                          layout: "total,sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "current-change": _vm.handleTicketPageChange,
                          "size-change": _vm.ticketSizeChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.applyFormVisible,
            "destroy-on-close": true,
            "append-to-body": "",
            "custom-class": "myFormDrawer",
            size: "88%",
            title: _vm.drawerTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.applyFormVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("applyForm", {
            attrs: {
              visible: _vm.applyFormVisible,
              type: _vm.applyFormType,
              id: _vm.selectedId,
              projectType: _vm.selectedProjectType,
              projectStatus: _vm.selectedProjectStatus,
              rejectedTaskTypes: _vm.selectedRejectedTaskTypes,
            },
            on: {
              "update:visible": function ($event) {
                _vm.applyFormVisible = $event
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.ticketDrawerVisible,
            "destroy-on-close": true,
            "append-to-body": "",
            "custom-class": "myFormDrawer",
            size: "88%",
            title: _vm.ticketFormType === "view" ? "工单详情" : "事项咨询",
          },
          on: {
            "update:visible": function ($event) {
              _vm.ticketDrawerVisible = $event
            },
          },
        },
        [
          _c("ticketForm", {
            attrs: {
              visible: _vm.ticketDrawerVisible,
              id: _vm.ticketFormId,
              type: _vm.ticketFormType,
              customerName: _vm.ticketFormCustomerName,
            },
            on: {
              "update:visible": function ($event) {
                _vm.ticketDrawerVisible = $event
              },
              success: _vm.handleTicketFormSuccess,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设计确认",
            visible: _vm.designConfirmVisible,
            width: "700px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.designConfirmVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "auto" } },
            [
              _c("el-form-item", { attrs: { label: "设计稿" } }, [
                _vm.designFileList.length
                  ? _c(
                      "div",
                      _vm._l(_vm.designFileList, function (item, idx) {
                        return _c(
                          "div",
                          { key: idx, staticClass: "design-item" },
                          [
                            _vm.isImageFile(item)
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        gap: "12px",
                                        "margin-bottom": "8px",
                                      },
                                    },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "120px",
                                          height: "80px",
                                          "flex-shrink": "0",
                                          border: "1px solid #ebeef5",
                                          "border-radius": "4px",
                                        },
                                        attrs: {
                                          src: _vm.$ossurl + item.url,
                                          fit: "contain",
                                          "preview-src-list": _vm.imageSrcList,
                                        },
                                      }),
                                      _c("el-button", {
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-download",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadDesignFile(item)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _c(
                                  "div",
                                  { staticClass: "fileItem" },
                                  [
                                    _c("span", { staticClass: "file-name" }, [
                                      _vm._v(_vm._s(item.file_name)),
                                    ]),
                                    _c("el-button", {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-download",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadDesignFile(item)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                          ],
                          2
                        )
                      }),
                      0
                    )
                  : _c(
                      "div",
                      {
                        staticStyle: { color: "#909399", "font-size": "13px" },
                      },
                      [_vm._v(" 暂无设计稿文件 ")]
                    ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "是否需要印刷", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.need_printing,
                        callback: function ($$v) {
                          _vm.need_printing = $$v
                        },
                        expression: "need_printing",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("需要"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("不需要"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.designConfirmVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmDesign },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报价单下单",
            visible: _vm.multiOrderVisible,
            width: "1200px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.multiOrderVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "order-summary" }, [
            _vm._v(" 报价单采购金额："),
            _c("span", { staticClass: "order-summary-num" }, [
              _vm._v(_vm._s(_vm.orderSummary.quotation)),
            ]),
            _vm._v(" 元，已使用 "),
            _c("span", { staticClass: "order-summary-num" }, [
              _vm._v(_vm._s(_vm.orderSummary.used)),
            ]),
            _vm._v(" 元，还可使用 "),
            _c("span", { staticClass: "order-summary-num" }, [
              _vm._v(_vm._s(_vm.orderSummary.available)),
            ]),
            _vm._v(" 元 "),
          ]),
          _c("div", { staticClass: "order-select-tip" }, [
            _vm._v("勾选要复制卡规则的订单后，【继续下单】按钮点亮"),
          ]),
          _c("saleOrderList", {
            attrs: {
              list: _vm.saleOrderList,
              loading: _vm.orderListLoading,
              selectable: "",
              "selected-id": _vm.selectedOrderId,
            },
            on: {
              "update:selectedId": function ($event) {
                _vm.selectedOrderId = $event
              },
              "update:selected-id": function ($event) {
                _vm.selectedOrderId = $event
              },
              detail: _vm.goOrderDetail,
            },
          }),
          _c(
            "div",
            {
              staticClass: "pages",
              staticStyle: { "text-align": "right", margin: "16px 0 0" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.orderListPages.currentPage,
                  "page-size": 20,
                  total: _vm.orderListPages.totalCount,
                  layout: "total, prev, pager, next, jumper",
                },
                on: { "current-change": _vm.handleViewOrderPageChange },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.multiOrderVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.selectedOrderId },
                  on: { click: _vm.continueOrder },
                },
                [_vm._v("继续下单")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单明细",
            visible: _vm.orderListVisible,
            width: "1200px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderListVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "order-summary" }, [
            _vm._v(" 报价单采购金额："),
            _c("span", { staticClass: "order-summary-num" }, [
              _vm._v(_vm._s(_vm.orderSummary.quotation)),
            ]),
            _vm._v(" 元，已使用 "),
            _c("span", { staticClass: "order-summary-num" }, [
              _vm._v(_vm._s(_vm.orderSummary.used)),
            ]),
            _vm._v(" 元，还可使用 "),
            _c("span", { staticClass: "order-summary-num" }, [
              _vm._v(_vm._s(_vm.orderSummary.available)),
            ]),
            _vm._v(" 元 "),
          ]),
          _c("saleOrderList", {
            attrs: { list: _vm.saleOrderList, loading: _vm.orderListLoading },
            on: { detail: _vm.goOrderDetail },
          }),
          _c(
            "div",
            {
              staticClass: "pages",
              staticStyle: { "text-align": "right", margin: "16px 0 0" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.orderListPages.currentPage,
                  "page-size": 20,
                  total: _vm.orderListPages.totalCount,
                  layout: "total, prev, pager, next, jumper",
                },
                on: { "current-change": _vm.handleViewOrderPageChange },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.orderListVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.createOrderDrawer,
            title: "创建订单",
            size: "88%",
            "custom-class": "order-create-drawer",
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createOrderDrawer = $event
            },
          },
        },
        [
          _vm.createOrderDrawer
            ? _c("saleCreateOrder", {
                attrs: {
                  isDrawer: true,
                  orderId: _vm.orderDrawerId,
                  saleProjectDeliveryId: _vm.saleProjectDeliveryId,
                },
                on: { onSuccess: _vm.handleCreateOrderSuccess },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }